export class Pricing{
    pk:number;
    service_pk:any;
    currency_pk:any;
    start_date:any;
    service_provider_pk:any;
    comments:any;
    price_data:any;

}




// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/pricing/model/pricing.ts